/* src/modules/course_approvals/reducers.js */

import { combineReducers } from 'redux';
import { map, keyBy } from 'lodash';

import {
  fetchCourseApprovalTutorsTypes,
  updateCourseApprovalTypes,
  addCoursesToTutorTypes,
  SELECT_COURSE_APPROVAL_TUTOR,
  SELECT_COURSE_APPROVAL_TUTOR_UNIVERSITY,
} from './action_types';

import { makeRequestReducer } from '../../config/client';

const initialState = {
  selected: '',
  selectedUniversity: '',
};

const updateCourseApproval = ({ data, selected }, res) => {
  const { course } = res;
  const replace = courseApprovals => map(courseApprovals, c => {
    if (c.course.subject === course.subject && c.course.number === course.number) return res;
    return c;
  });
  const tutor = data[selected];
  return { ...data, [selected]: { ...tutor, courses: replace(tutor.courses) } };
};

const main = makeRequestReducer({
  types: fetchCourseApprovalTutorsTypes,
  name: 'tutors',
  initialState,
  mutate: (state, res) => keyBy(res, '_id'),
  append: [
    (state, { type, payload }) => {
      switch (type) {
        case SELECT_COURSE_APPROVAL_TUTOR:
          return { ...state, selected: payload };
        case SELECT_COURSE_APPROVAL_TUTOR_UNIVERSITY:
          return { ...state, selectedUniversity: payload };
        default:
          return state;
      }
    },
    makeRequestReducer({
      types: updateCourseApprovalTypes,
      name: 'modifyCourseApprovalStatus',
      mutate: (state, res) => updateCourseApproval(state, res),
    }),
    makeRequestReducer({
      types: addCoursesToTutorTypes,
      name: 'addCoursesToTutor',
      mutate: (state, res) => ({ ...state.data, [res._id]: res }),
    }),
  ],
});

export default combineReducers({
  main,
});



// WEBPACK FOOTER //
// ./src/modules/course_approvals/reducers.js